<div class="flex-grow-1 py-3 mt-4">
  <div class="mb-3">
    <h1 class="fs-5 fw-bold mb-0">Advertiser report</h1>
  </div>

  <div class="card shadow border-0 mb-3 fade-in-zoom">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-auto">
          <app-date-range-selector [date]="'this-month'" [zone]="'Europe/Paris'" (dateChanged)="dateChanged($event)"></app-date-range-selector>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Advertiser</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [selectAll]="true" [(ngModel)]="filters.values['advertisers']" (ngModelChange)="onAdvertiserChange()" placeholder="All advertisers">
              @for (advertiser of advertisers; track advertiser.id) {
                <app-dropdown-select-option [value]="advertiser.id">{{ advertiser.companyName }}</app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Brand</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [selectAll]="true" [(ngModel)]="filters.values['products']" placeholder="All products">
              @for (product of filteredProducts; track product.id) {
                <app-dropdown-select-option [value]="product.id">{{ product.name }}</app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Account type</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [(ngModel)]="filters.values['partnerAccountType']">
              <app-dropdown-select-option value="affiliate">Affiliate</app-dropdown-select-option>
              <app-dropdown-select-option value="mediabuy">Media Buy</app-dropdown-select-option>
              <app-dropdown-select-option value="internal">Internal</app-dropdown-select-option>
            </app-dropdown-select>
          </div>
        </div>

        <div class="col-auto">
          <button class="btn btn-primary fw-bold" (click)="applyFilters()">
            <i class="bi bi-search me-1"></i> Apply
          </button>
          <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
            <i class="bi bi-floppy"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
            <i class="bi bi-eraser"></i>
          </button>
        </div>

        <div class="col-auto ms-auto">
          <button class="btn btn-outline-primary fw-bold" (click)="downloadCsv()" [disabled]="loading">
            <i class="bi bi-file-earmark-spreadsheet me-1"></i> Download CSV
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (!loading) {
    <div class="card border-0 shadow mb-3">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th class="cursor-pointer" (click)="sort('name')">
                  Company <i class="bi ms-1" [ngClass]="getSortIcon('name')"></i>
                </th>
                <th class="text-end cursor-pointer" (click)="sort('volume')">
                  Volume of leads <i class="bi ms-1" [ngClass]="getSortIcon('volume')"></i>
                </th>
                <th class="text-end border-success-subtle bg-success-subtle cursor-pointer" (click)="sort('averageCplUsd')">
                  Avg CPL (USD) <i class="bi ms-1" [ngClass]="getSortIcon('averageCplUsd')"></i>
                </th>
                <th class="text-end border-success-subtle bg-success-subtle cursor-pointer" (click)="sort('averageCplEur')">
                  Avg CPL (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('averageCplEur')"></i>
                </th>
                <th class="text-end bg-warning-subtle cursor-pointer" (click)="sort('spentUsd')">
                  Spent (USD) <i class="bi ms-1" [ngClass]="getSortIcon('spentUsd')"></i>
                </th>
                <th class="text-end bg-warning-subtle cursor-pointer" (click)="sort('spentEur')">
                  Spent (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('spentEur')"></i>
                </th>
                <th class="text-end bg-info-subtle cursor-pointer" (click)="sort('totalSpentUsd')">
                  Total spent (USD) <i class="bi ms-1" [ngClass]="getSortIcon('totalSpentUsd')"></i>
                </th>
                <th class="text-end bg-info-subtle cursor-pointer" (click)="sort('totalSpentEur')">
                  Total spent (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('totalSpentEur')"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (company of rows; track company.id) {
                <!-- Company row (Level 0) -->
                <tr class="cursor-pointer" (click)="toggleCompany(company.id)">
                  <td class="fw-bold">
                    <i class="bi me-1" [class.bi-chevron-right]="isCompanyCollapsed(company.id)"
                       [class.bi-chevron-down]="!isCompanyCollapsed(company.id)"></i>
                    {{ company.name }}
                  </td>
                  <td class="text-end">{{ company.totals.volume }}</td>
                  <td class="text-end bg-success-subtle">{{ company.totals.averageCplUsd | money:2:'USD' }}</td>
                  <td class="text-end bg-success-subtle">{{ company.totals.averageCplEur | money:2:'EUR' }}</td>
                  <td class="text-end bg-warning-subtle">{{ company.totals.spentUsd | money:2:'USD' }}</td>
                  <td class="text-end bg-warning-subtle">{{ company.totals.spentEur | money:2:'EUR' }}</td>
                  <td class="text-end bg-info-subtle">{{ company.totals.totalSpentUsd | money:2:'USD' }}</td>
                  <td class="text-end bg-info-subtle">{{ company.totals.totalSpentEur | money:2:'EUR' }}</td>
                </tr>

                @if (!isCompanyCollapsed(company.id)) {
                  @for (product of company.products; track product.id) {
                    <!-- Product row (Level 1) -->
                    <tr class="table-light cursor-pointer" (click)="toggleProduct(company.id, product.id)">
                      <td class="ps-4">
                        <i class="bi me-1" [class.bi-chevron-right]="isProductCollapsed(company.id, product.id)"
                           [class.bi-chevron-down]="!isProductCollapsed(company.id, product.id)"></i>
                        {{ product.name }}
                      </td>
                      <td class="text-end">{{ product.totals.volume }}</td>
                      <td class="text-end bg-success-subtle">{{ product.totals.averageCplUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-success-subtle">{{ product.totals.averageCplEur | money:2:'EUR' }}</td>
                      <td class="text-end bg-warning-subtle">{{ product.totals.spentUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-warning-subtle">{{ product.totals.spentEur | money:2:'EUR' }}</td>
                      <td class="text-end bg-info-subtle">{{ product.totals.totalSpentUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-info-subtle">{{ product.totals.totalSpentEur | money:2:'EUR' }}</td>
                    </tr>

                    @if (!isProductCollapsed(company.id, product.id)) {
                      <!-- Partner rows (Level 2) -->
                      @for (partner of product.partners; track partner.id) {
                        <tr>
                          <td class="ps-5">{{ partner.name || '-' }}</td>
                          <td class="text-end">{{ partner.volume }}</td>
                          <td class="text-end bg-success-subtle">{{ partner.averageCplUsd | money:2:'USD' }}<span class="text-danger fa-fw ms-2">{{ partner.currency === 'USD' ? '¤' : ' ' }}</span></td>
                          <td class="text-end bg-success-subtle">{{ partner.averageCplEur | money:2:'EUR' }}<span class="text-danger fa-fw ms-2">{{ partner.currency === 'EUR' ? '¤' : ' ' }}</span></td>
                          <td class="text-end bg-warning-subtle">{{ partner.spentUsd | money:2:'USD' }}<span class="text-danger fa-fw ms-2">{{ partner.currency === 'USD' ? '¤' : ' ' }}</span></td>
                          <td class="text-end bg-warning-subtle">{{ partner.spentEur | money:2:'EUR' }}<span class="text-danger fa-fw ms-2">{{ partner.currency === 'EUR' ? '¤' : ' ' }}</span></td>
                          <td class="text-end bg-info-subtle">{{ partner.totalSpentUsd | money:2:'USD' }}</td>
                          <td class="text-end bg-info-subtle">{{ partner.totalSpentEur | money:2:'EUR' }}</td>
                        </tr>
                      }

                      <!-- Product TOTAL row -->
                      <tr class="fw-bold">
                        <td class="ps-5">TOTAL</td>
                        <td class="text-end">{{ product.totals.volume }}</td>
                        <td class="text-end bg-success-subtle">{{ product.totals.averageCplUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-success-subtle">{{ product.totals.averageCplEur | money:2:'EUR' }}</td>
                        <td class="text-end bg-warning-subtle">{{ product.totals.spentUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-warning-subtle">{{ product.totals.spentEur | money:2:'EUR' }}</td>
                        <td class="text-end bg-info-subtle">{{ product.totals.totalSpentUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-info-subtle">{{ product.totals.totalSpentEur | money:2:'EUR' }}</td>
                      </tr>
                    }
                  }
                }
              }
            </tbody>
            <tfoot>
              <tr class="fw-bold">
                <td>GRAND TOTAL</td>
                <td class="text-end">{{ totals.volume }}</td>
                <td class="text-end">{{ totals.averageCplUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.averageCplEur | money:2:'EUR' }}</td>
                <td class="text-end">{{ totals.spentUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.spentEur | money:2:'EUR' }}</td>
                <td class="text-end">{{ totals.totalSpentUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.totalSpentEur | money:2:'EUR' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  }
</div>
